import React from 'react';
import styled from 'styled-components';

import Wrapper from '../../elements/wrapper';
import { media } from '../../helpers';

import Circles from '../../../images/about-banner-circles.inline.svg';

const FeaturedBannerContainer = styled.div`
    .banner-color-bg {
        min-height: 60vh;
        max-width: 100vw;
        position: relative;
        @media (max-width: 400px) {
            min-height: 65vh;
        }

        .banner-content-wrapper {
            text-align: center;
            padding: 18vh 0 0;
            ${media.small`padding: 22vh 0 0;`};
            ${media.large`padding: 24vh 0 0;`};
            h1 {
                color: #fff;
                font-size: 2.5rem;
                font-weight: 800;
                font-family: neue-kabel, sans-serif;
                ${media.large`font-size: 3.7rem;`};
            }

            p {
                color: #fff;
                max-width: 750px;
                margin: 0 auto;
                font-size: 1.2rem;
                line-height: 1.5;
            }
        }
        .svg-container {
            svg {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 100%;

                g {
                    mask: none;
                }
            }
        }
    }
`;

const FeaturedBanner = ({ content }) => {
    const { bannerBackgroundColor, bannerCaption, bannerHeadline } =
        content || {};
    return (
        <FeaturedBannerContainer>
            <Wrapper
                className="banner-color-bg"
                style={{ background: bannerBackgroundColor }}
            >
                <Wrapper className="banner-content-wrapper">
                    <h1>{bannerHeadline}</h1>
                    <p>{bannerCaption}</p>
                </Wrapper>
                <div className="svg-container">
                    <Circles />
                </div>
            </Wrapper>
        </FeaturedBannerContainer>
    );
};

export default FeaturedBanner;
